import COS from 'cos-js-sdk-v5';

import { getCosBucket } from '@/services/common';
import { guuid } from '@/utils/utils';

let bucket;
let region;
let folder;

const getAuthorization = function (options, callback) {
  // 格式一、（推荐）后端通过获取临时密钥给到前端，前端计算签名
  // 服务端 JS 和 PHP 例子：https://github.com/tencentyun/cos-js-sdk-v5/blob/master/server/
  // 服务端其他语言参考 COS STS SDK ：https://github.com/tencentyun/qcloud-cos-sts-sdk
  // var url = '../server/sts.php'; // 如果起的是 php server 用这个
  const url = '/tencent/cosUpToken'; // 如果是 npm run sts.js 起的 nodejs server，使用这个
  const xhr = new XMLHttpRequest();
  xhr.open('POST', UMI_API_SERVER + url, true);
  // 允许跨域发送cookie
  // xhr.withCredentials = true;
  // xhr.setRequestHeader('Content-Type', 'application/json');
  // eslint-disable-next-line consistent-return
  xhr.onload = function (e) {
    let data;
    let credentials;

    try {
      data = JSON.parse(e.target.responseText).data;
      // console.log('上传秘钥', data);
      // credentials = data.credentials;
      credentials = data.tmpSecret;
      // bucket = data.bucket;
      // region = data.region;
      // folder = data.folder;
      // eslint-disable-next-line no-empty
    } catch (ee) {
      // eslint-disable-next-line no-console
      console.log(ee);
    }

    if (!data || !credentials) {
      // return console.error(`credentials invalid:${  JSON.stringify(data, null, 2)}`);
    }

    const authorization = COS.getAuthorization({
      SecretId: credentials.tmpSecretId, // 可传固定密钥或者临时密钥
      SecretKey: credentials.tmpSecretKey, // 可传固定密钥或者临时密钥
      Method: options.Method,
      Pathname: options.Pathname,
      Query: options.Query,
      Headers: options.Headers,
      Expires: 900,
    });

    callback({
      Authorization: authorization,
      // XCosSecurityToken: credentials.sessionToken,
      XCosSecurityToken: credentials.token,
    });

    // callback({
    //   TmpSecretId: credentials.tmpSecretId,
    //   TmpSecretKey: credentials.tmpSecretKey,
    //   SecurityToken: credentials.token,
    //   StartTime: data.startTime, // 时间戳，单位秒，如：1580000000，建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
    //   ExpiredTime: data.expiredTime, // 时间戳，单位秒，如：1580000000
    //   ScopeLimit: true, // 细粒度控制权限需要设为 true，会限制密钥只在相同请求时重复使用
    // });
  };
  // xhr.send(JSON.stringify(options.Scope));
  xhr.send('{}');
};
const cos = new COS({
  getAuthorization,
  UploadCheckContentMd5: true,
});

export function putObject({
  filename,
  file,
  onProgress,
  callback,
  host,
  isCustomPath,//自定义路径host
}) {
  if (region) {
    let regionkey = undefined;

    if (host) {
      if (isCustomPath) {
        regionkey = `${host}${filename}`; /* 文件名 必须 */
      } else {
        regionkey = `${folder}/${host}/${guuid() + filename}`; /* 文件名 必须 */
      }
    } else {
      regionkey = `${folder}/palmer-res/${
        guuid() + filename
      }`; /* 文件名 必须 */
    }
    cos.putObject(
      {
        Bucket: bucket /* 必须 */,
        Region: region /* 存储桶所在地域，必须字段 */,
        Key: regionkey /* 文件名 必须 */,
        StorageClass: 'STANDARD',
        Body: file, // 上传文件对象
        onProgress:
          onProgress ||
          function (progressData) {
            // eslint-disable-next-line no-console
            console.log('progressData___', JSON.stringify(progressData));
          },
      },
      callback ||
        function (err, data1) {
          // eslint-disable-next-line no-console
          console.log('上传结果', err || data1);
        },
    );
    return;
  }
  getCosBucket().then(({ code, data }) => {
    if (code === '00000') {
      region = data.region;
      bucket = data.bucket;
      folder = data.folder;
      // const { region, bucket, folder } = data;

      let key = undefined;
      if (host) {
        if (isCustomPath) {
          key = `${host}${ filename}`; /* 文件名 必须 */
        } else {
          key = `${folder}/${host}/${guuid() + filename}`; /* 文件名 必须 */
        }
      } else {
        key = `${folder}/palmer-res/${guuid() + filename}`; /* 文件名 必须 */
      }
      cos.putObject(
        {
          Bucket: bucket /* 必须 */,
          Region: region /* 存储桶所在地域，必须字段 */,
          Key: key /* 文件名 必须 */,
          StorageClass: 'STANDARD',
          Body: file, // 上传文件对象
          onProgress:
            onProgress ||
            function (progressData) {
              // eslint-disable-next-line no-console
              console.log('progressData___', JSON.stringify(progressData));
            },
        },
        callback ||
          function (err, data1) {
            // eslint-disable-next-line no-console
            console.log('上传结果', err || data1);
          },
      );
    }
  });
}

export default cos;
